import home from "@/views/home/index.vue";
import setting from "@/views/system/setting.vue"
import BrandSetting from "@/views/system/brand-setting.vue"
import Personnel from '@/views/system/Personnel.vue'
import ChangePsw from "@/views/system/ChangePsw.vue";
import Device from "@/views/system/Device.vue";
import DeviceDetail from "@/views/system/DeviceDetail.vue";
import DeviceWorkTimeStats from "@/views/system/DeviceWorkTimeStats.vue";
import DeviceUtilization from "@/views/system/DeviceUtilization.vue";
import DeviceTemplate from "@/views/system/DeviceTemplate.vue";
import Feedback from "@/views/feedback";
import ClockIn from "@/views/attendance/ClockIn.vue";
import Special from "@/views/task/special.vue";
import SubmitRecord from "@/views/task/submitRecord.vue";
import Score from "@/views/score/score.vue";
import Maintenance from "@/views/maintenance/maintenance.vue";
import Record from "@/views/attendance/Record.vue";
import OTRecord from "@/views/attendance/OTRecord.vue";
import Improve from "@/views/improve/improve.vue";
import ImproveRecord from "@/views/improve/submitRecords.vue";
import ScoreRule from "@/views/score/rule.vue";
import Sign from "@/views/attendance/Sign.vue";
import Machinist from "@/views/machinist/machinist.vue";
import MachinistDetail from "@/views/machinist/detail.vue";
import MaintenanceRecord from "@/views/maintenance/submitRecord.vue";
import DeviceDuplicateRecord from "@/views/maintenance/deviceDuplicateRecord.vue";
import RewardRecord from "@/views/score/rewardRecord.vue";
import ClockRemind from "@/views/attendance/remind.vue"
import RewardRemind from "@/views/score/remind.vue"
import Lottery from "@/views/score/lottery.vue";
import LotteryRecord from "@/views/score/lotteryRecord.vue";
// import BindUserList from "@/views/system/bindUserList.vue";
import Captain from "@/views/captain/captain.vue";
import CaptainDetail from "@/views/captain/detail.vue";
import CaptainSpecialTask from "@/views/captain-special/special.vue";
import CaptainSpecialTaskSubmitRecord from "@/views/captain-special/submitRecord.vue";
import CaptainMachinist from "@/views/captain-machinist/machinist.vue";
import Summary from "@/views/attendance/Summary.vue"
import salary from "@/views/attendance/salary.vue"
import Anomaly from "@/views/attendance/Anomaly.vue"
import AnnualLeave from "@/views/attendance/AnnualLeave.vue"
import AnnualLeaveBalance from "@/views/attendance/AnnualLeaveBalance.vue"
import AnnualLeaveRule from "@/views/attendance/AnnualLeaveRule.vue"
import CaptainReview from "@/views/attendance/CaptainReview.vue"
import Message from "@/views/message/Message.vue"
import OperationLogs from "@/views/system/operation-logs.vue"
export const tenantRoutes = [
    {
        path: "/home",
        name: "home",
        title: "应用首页",
        icon: 'HomeFilled',
        component: home,
    },
    {
        path: '/attendance',
        name: 'attendance',
        title: '考勤管理',
        icon: 'Clock',
        children: [
            {
                path: '/attendance',
                name: 'attendanceList',
                title: '打卡记录',
                icon: 'List',
                component: Record,
            },
            {
                path: '/attendance/overtime',
                name: 'overtime',
                title: 'OT/中直记录',
                icon: 'Tickets',
                component: OTRecord,
            },
            {
                path: '/attendance/Summary',
                name: 'Summary',
                title: '打卡汇总',
                icon: 'Calendar',
                component: Summary,
            },
            {
                path: '/attendance/salary',
                name: 'salary',
                title: '员工工资条',
                icon: 'Calendar',
                component: salary,
            },
            
            {
                path: '/attendance/clockIn',
                name: 'clockIn',
                title: '打卡地点',
                icon: 'LocationFilled',
                component: ClockIn,
            },
            {
                path: '/attendance/sign',
                name: 'sign',
                title: '签字记录',
                icon: 'EditPen',
                component: Sign,
            },
            {
                path: '/attendance/clockRemind',
                name: 'clockRemind',
                title: '打卡须知',
                icon: 'WarnTriangleFilled',
                component: ClockRemind,
            },
            {
                path: '/attendance/anomaly',
                name: 'attendanceAnomaly',
                title: '考勤异常',
                icon: 'Warning',
                component: Anomaly,
            },
            {
                path: '/attendance/annualLeave',
                name: 'attendanceAnnualLeave',
                title: '请假/年假审核',
                icon: 'Document',
                permission: 'captain',
                component: AnnualLeave,
            },
            {
                path: '/attendance/annualLeaveBalance',
                name: 'attendanceAnnualLeaveBalance',
                title: '年假余额配置',
                icon: 'Edit',
                component: AnnualLeaveBalance,
            },
            {
                path: '/attendance/annualLeaveRule',
                name: 'attendanceAnnualLeaveRule',
                title: '入职年限与年假天数',
                icon: 'Memo',
                component: AnnualLeaveRule,
            },
            {
                path: '/attendance/captainReview',
                name: 'attendanceCaptainReview',
                title: '队长打卡审核',
                icon: 'Checked',
                component: CaptainReview,
            }
        ]
    },
    {
        path: '/equipment',
        name: 'equipment',
        title: '设备管理',
        icon: 'Operation',
        children: [
            {
                path: '/equipment',
                name: 'deviceTemplate',
                title: '设备模板',
                icon: 'DocumentCopy',
                component: DeviceTemplate,
            },
            {
                path: '/equipment/device',
                name: 'equipmentList',
                title: '设备列表',
                icon: 'List',
                component: Device,
            },
            {
                path: '/equipment/workTimeStats',
                name: 'deviceWorkTimeStats',
                title: '设备工时统计',
                icon: 'DataAnalysis',
                component: DeviceWorkTimeStats,
            },
            {
                path: '/equipment/utilization',
                name: 'deviceUtilization',
                title: '设备利用率对比',
                icon: 'Histogram',
                component: DeviceUtilization,
            },
            {
                path: '/equipment/maintenance',
                name: 'maintenanceRecord',
                title: '保养记录',
                icon: 'Tickets',
                component: MaintenanceRecord,
            },
            {
                path: '/equipment/device-duplicate-record',
                name: 'deviceDuplicateRecord',
                title: '设备选重记录',
                icon: 'WarningFilled',
                component: DeviceDuplicateRecord,
            }
        ]
    },
    {
        path: '/task',
        name: 'task',
        title: '特殊任务',
        icon: 'BrushFilled',
        children: [
            {
                path: '/task',
                name: 'specialTask',
                title: '特殊任务',
                icon: 'BrushFilled',
                component: Special,
            },
            {
                path: '/task/submitRecord',
                name: 'specialTaskSubmitRecord',
                title: '提交记录',
                icon: 'Tickets',
                component: SubmitRecord,
            },
        ]
    },
    {
        path: '/captain-task',
        name: 'captainTask',
        title: '特殊任务',
        icon: 'BrushFilled',
        permission: "captain",
        children: [
            {
                path: '/captain-task',
                name: 'captainSpecialTask',
                title: '特殊任务',
                icon: 'BrushFilled',
                component: CaptainSpecialTask,
            },
            {
                path: '/captain-task/submitRecord',
                name: 'captainSpecialTaskSubmitRecord',
                title: '提交记录',
                icon: 'Tickets',
                component: CaptainSpecialTaskSubmitRecord,
            },
        ]
    },
    {
        path: '/captain-maintenance',
        name: 'captainMaintenance',
        title: '保养任务',
        icon: 'Tools',
        permission: "captain",
        children: [
            {
                path: '/captain-maintenance',
                name: 'captainMaintenanceSubmitRecord',
                title: '提交记录',
                icon: 'Tickets',
                component: MaintenanceRecord,
            },
        ]
    },
    {
        path: '/improve',
        name: 'improve',
        title: '技能提升',
        icon: 'Stamp',
        children: [
            {
                path: '/improve',
                name: 'improveTask',
                title: '任务列表',
                icon: 'List',
                component: Improve,
            },
            {
                path: '/improve/submitRecord',
                name: 'improveTaskSubmitRecord',
                title: '提交记录',
                icon: 'Tickets',
                component: ImproveRecord,
            },
        ]
    },
    {
        path: '/score',
        name: 'score',
        title: '积分管理',
        icon: 'Coin',
        children: [
            {
                path: '/score',
                name: 'scoreRule',
                title: '积分规则',
                icon: 'Collection',
                component: ScoreRule,
            },
            {
                path: '/score/record',
                name: 'scoreRecord',
                title: '积分记录',
                icon: 'Memo',
                component: Score,
            },
            {
                path: '/score/rewardRecord',
                name: 'rewardRecord',
                title: '兑换记录',
                icon: 'ShoppingCartFull',
                component: RewardRecord,
            },
            {
                path: '/score/remind',
                name: 'rewardRemind',
                title: '积分使用说明',
                icon: 'WarningFilled',
                component: RewardRemind,
            },
            {
                path: '/score/lottery',
                name: 'lottery',
                title: '积分抽奖',
                icon: 'Present',
                component: Lottery,
            },
            {
                path: '/score/lotteryRecord',
                name: 'lotteryRecord',
                title: '抽奖记录',
                icon: 'Tickets',
                component: LotteryRecord,
            },
        ],
    },
    {
        path: '/feedback',
        name: 'feedback',
        title: '用户反馈',
        icon: 'BellFilled',
        component: Feedback,
    },
    {
        path: '/system',
        name: 'system',
        title: '系统维护',
        icon: 'Tools',
        children: [
            {
                path: '/system',
                name: 'userList',
                title: '用户列表',
                icon: 'UserFilled',
                component: Personnel,
            },
            // {
            //     path: '/system/bindUser',
            //     name: 'BindUserList',
            //     title: '关联机手',
            //     icon: 'UserFilled',
            //     component: BindUserList,
            // },
            {
                path: '/system/setting',
                name: 'setting',
                title: '系统参数',
                icon: 'Setting',
                component: setting,
            },
            {
                path: '/system/brand-setting',
                name: 'brandSetting',
                title: '品牌设置',
                icon: 'Brush',
                component: BrandSetting,
            },
            {
                path: '/system/ChangePsw',
                name: 'ChangePsw',
                title: '修改密码',
                icon: 'Key',
                component: ChangePsw,
            },
            {
                path: '/system/message',
                name: 'message',
                title: '消息管理',
                icon: 'Message',
                component: Message,
            },
            {
                path: '/system/operation-logs',
                name: 'operationLogs',
                title: '操作审计',
                icon: 'Document',
                component: OperationLogs,
            },
        ]
    },
    {
        path: '/Machinist',
        name: 'machinist',
        title: '机手管理',
        icon: 'Avatar',
        component: Machinist,
    },
    {
        path: '/captain-Machinist',
        name: 'captainMachinist',
        title: '机手管理',
        icon: 'Avatar',
        permission: 'captain',
        component: CaptainMachinist,
    },
    {
        path: '/Captain',
        name: 'Captain',
        title: '队长管理',
        icon: 'User',
        component: Captain,
    },
    {
        path: '/maintenance',
        name: 'maintenance',
        title: '保养计划',
        icon: 'List',
        component: Maintenance,
        show: false
    },
    {
        path: '/machinist-detail',
        name: 'machinist-detail',
        title: '机手详情',
        icon: 'List',
        component: MachinistDetail,
        show: false
    },
    {
        path: '/captain-detail',
        name: 'captain-detail',
        title: '队长详情',
        icon: 'List',
        component: CaptainDetail,
        show: false
    },
    {
        path: '/equipment/device-detail',
        name: 'device-detail',
        title: '设备详情',
        icon: 'List',
        component: DeviceDetail,
        show: false
    },
]